window.addEventListener("load", function () {
    if ($('#MS__wrapper.iframe').length > 0) return;

    // Thumb swiper (enable loop)
    var swiperThumb = new Swiper(".swiper-faces-thumb", {
        direction: "horizontal",
        slidesPerView: 1,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true, // giúp xác định slide đang ở vùng nhìn thấy
        slideToClickedSlide: true,
        navigation: {
            nextEl: ".swiper-button-next-faces",
            prevEl: ".swiper-button-prev-faces",
        },
        pagination: {
            el: ".swiper-pagination-faces",
        },
        loop: true,
        // optional: explicitly set number of looped slides if needed
        // loopedSlides: 8,
        breakpoints: {
            768: {
                direction: "vertical",
                slidesPerView: 3,
                centeredSlides: true,
            },
        },
    });

    // Main swiper (enable loop)
    var swiperMain = new Swiper(".swiper-faces", {
        direction: "horizontal",
        breakpoints: {
            768: {
                direction: "vertical",
            },
        },
        thumbs: {
            swiper: swiperThumb,
        },
        loop: true,
        // loopedSlides: 8,
    });



    // Helper to navigate respecting loop duplicates
    function goToLoop(swiperInstance, index) {
        if (typeof swiperInstance.slideToLoop === 'function') {
            swiperInstance.slideToLoop(index);
        } else {
            // Fallback: find a slide with matching data-swiper-slide-index
            var target = swiperInstance.slides.filter ? swiperInstance.slides.filter(function (s) { return s.getAttribute('data-swiper-slide-index') == index; }) : [];
            swiperInstance.slideTo(index + (swiperInstance.params.loop ? swiperInstance.loopedSlides : 0));
        }
    }

    // Sync: thumb -> main (use realIndex in loop mode)
    swiperThumb.on('slideChange', function () {
        var i = swiperThumb.realIndex;
        if (swiperMain.realIndex !== i) {
            goToLoop(swiperMain, i);
        }
    });

    // Sync: main -> thumb
    swiperMain.on('slideChange', function () {
        var i = swiperMain.realIndex;
        if (swiperThumb.realIndex !== i) {
            goToLoop(swiperThumb, i);
        }
    });

    const isPC = $('body').data('device-type') === 'desktop';
    if (isPC) {
        function updateThumbClasses() {
            // Xóa class cũ khỏi toàn bộ slides (bao gồm duplicates) để trạng thái sạch
            swiperThumb.slides.forEach(function (slide) {
                slide.classList.remove('swiper-slide-prev2', 'swiper-slide-next2');
            });

            // Tính tổng slide gốc (loại duplicates) để xoay vòng chỉ số
            var originalSlides = swiperThumb.$wrapperEl ? swiperThumb.$wrapperEl[0].querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)') : [];
            var total = originalSlides.length || 0;
            if (!total) return;

            var realIndex = swiperThumb.realIndex;
            var prev2 = (realIndex - 2 + total) % total;
            var next2 = (realIndex + 2) % total;

            // Thêm class cho cả slide gốc lẫn duplicates đang hiển thị (Swiper loop dùng duplicates hiển thị)
            var wrapperEl = swiperThumb.$wrapperEl && swiperThumb.$wrapperEl[0];
            if (!wrapperEl) return;

            wrapperEl.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + prev2 + '"]').forEach(function (s) {
                s.classList.add('swiper-slide-prev2');
            });
            wrapperEl.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + next2 + '"]').forEach(function (s) {
                s.classList.add('swiper-slide-next2');
            });
        }

        // Update on relevant events
        swiperThumb.on('slideChange', updateThumbClasses);
        swiperThumb.on('init', updateThumbClasses);
        // Some Swiper versions emit 'loopFix' during loop transitions
        swiperThumb.on && swiperThumb.on('loopFix', updateThumbClasses);
        swiperThumb.on('slideChangeTransitionEnd', updateThumbClasses);

        updateThumbClasses();
    }

    // reachEnd handler removed because loop mode keeps cycling automatically
});
